var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.611 0c1.436 0 1.71.56 2.306 1.159l4.601 4.634c.769.772.394 1.158-.375 1.93L7.685 11.2c-.768.773-1.153 1.159-1.921.386L1.153 6.951C.555 6.351 0 6.18 0 4.634V1.992C0 .894.9 0 2.01 0ZM3.476 2.012c-.772 0-1.407.588-1.48 1.35l-.006.144c0 .777.584 1.415 1.342 1.487L3.476 5c.773 0 1.408-.587 1.48-1.35l.007-.144c0-.825-.66-1.494-1.487-1.494"
})));
export default SvgLabel;